import { CfPageExtra } from "types/pages/types";
import { graphql, useStaticQuery } from "gatsby";

export function useGetNewsEventsCategories(nodeLocale = "it") {
  const { allContentfulNewsEventsCategoryV2 } = useStaticQuery(graphql`
    query {
      allContentfulNewsEventsCategoryV2 {
        nodes {
          ... on ContentfulNewsEventsCategoryV2 {
            ...NewsEventsCategoryV2
          }
        }
      }
    }
  `);

  const pages = allContentfulNewsEventsCategoryV2.nodes;

  let currentPages = [];

  // FILTER LANG
  currentPages = pages.filter((page: CfPageExtra) => {
    if (page.node_locale !== nodeLocale) {
      return false;
    }
    return page;
  });

  return currentPages;
}
